import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  getMultiBookingList,
} from "../../new-booking-form/new-booking-form.slice";
import { Typography } from "@mui/material";
import { PAYMENT_OPTIONS } from "../../../config/constant";

const GroupBookingDetails = ({ groupId, defaultShowList=true }) => {
  const dispatch = useDispatch();
  const { multiBookingListData } = useSelector((state) => state.newBookingForm);
  const { t } = useTranslation();
  const [showList, setShowList] = useState(defaultShowList)
  useEffect(() => {
    dispatch(getMultiBookingList({ groupId }));
    // return () => {
    //   dispatch(resetMultiBookingListData());
    // };
  }, [dispatch, groupId]);

  return (
    <div className="otherApplicantDetails paymentDetails">
      <div className="applicantDetailsCard">
        <h3 className="titlePersonalHD marginBottom28">
          {t("groupBookingPreview.groupBookingTitle")}
        </h3>
        <p className="paymentP">
          <b>
            {t("groupBookingPreview.noOfUnits")}
            {multiBookingListData?.opportunities?.length || "N/A"}
          </b>

          {!defaultShowList && (
            <button
              type="button"
              className="viewUnitsBtn"
              onClick={() => setShowList((prev) => !prev)}
            >
              {t("groupBookingPreview.viewListBtn")}
            </button>
          )}
        </p>

        {(!defaultShowList && multiBookingListData?.groupDetails?.paymentMethod === PAYMENT_OPTIONS.LUMPSUM) && (
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: 600,
              fontStyle: "italic",
              mb: 2,
            }}
          >
            {t("groupBookingPreview.note")}
          </Typography>
        )}

        {showList && (
          <div className="tbResponsive">
            <table>
              <tr>
                <th style={{ color: "#1C252E" }}>
                  {t("groupBookingPreview.projectName")}
                </th>
                <th style={{ color: "#1C252E" }}>
                  {t("groupBookingPreview.unit")}
                </th>
                <th style={{ color: "#1C252E" }}>
                  {t("groupBookingPreview.saleValue")}
                </th>
                <th style={{ color: "#1C252E" }}>
                  {t("groupBookingPreview.bookingAmount")}
                </th>
              </tr>
              {multiBookingListData?.opportunities?.length > 0 &&
                multiBookingListData?.opportunities?.map((booking, index) => {
                  return (
                    <tr key={booking.Id || index}>
                      <td>{booking.Project ? booking.Project : "N/A"}</td>
                      <td>{booking?.unitno ? booking?.unitno : "N/A"}</td>
                      <td>
                        <span>₹&nbsp;</span>
                        <span>
                          {booking?.SalesValue
                          ? Number(booking?.SalesValue).toLocaleString("en-IN")
                            : 0}
                        </span>
                      </td>
                      <td>
                        <span>₹&nbsp;</span>
                        <span>
                          {booking.Amount
                            ? Number(booking?.Amount).toLocaleString("en-IN")
                            : 0}
                        </span>
                      </td>
                    </tr>
                  );
                })}
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default GroupBookingDetails;
